import { Stack } from "@mui/material";
import React from "react";

import { cn } from "../../utils/styling";
import LegendBullet from "./LegendBullet";

export const GeneralChartLegend = ({ className, direction, legends, onLegendClick, showValue }) => {
  return (
    <Stack className={cn("flex-wrap ", className)} direction={direction} spacing={4}>
      {legends?.map((legend, index) => {
        return (
          <Stack
            className={cn(
              onLegendClick && "cursor-pointer rounded p-1 hover:bg-lds-selection-subtle",
              direction === "column" && "w-full",
              legend.className
            )}
            key={index}
            onClick={() => onLegendClick?.(legend)}
            spacing={2}
          >
            <LegendBullet color={legend.color} height="0.8rem" type="circle" width="0.8rem" />
            <span className="py-[2px] font-ds-body-semibold-sm">{legend.label}</span>
            {showValue && <span className="text-lds-foreground-muted font-ds-body-semibold-lg">{legend.value}</span>}
          </Stack>
        );
      })}
    </Stack>
  );
};
